module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form navbar-right",
    attrs: {
      "role": "search"
    }
  }, [_c('div', {
    staticClass: "form-group is-empty"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "material-input"
  })]), _c('md-button', {
    staticClass: "btn btn-white btn-round btn-just-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("onSearchClick", _vm.searchText)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _c('div', {
    staticClass: "ripple-container"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aafbcd0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/navbar-search.vue
// module id = 1625
// module chunks = 0